import { useEffect, useRef } from 'react';

const stats = [
  { num: '2+', label: 'Ans d\'expérience' },
  { num: '10+', label: 'Projets livrés' },
  { num: '15+', label: 'Technologies maîtrisées' },
  { num: '100%', label: 'Clients satisfaits' },
];

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('visible'); },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

export function StatsBar() {
  return (
    <div className="stats-bar">
      <div className="stats-grid">
        {stats.map(s => (
          <div className="stat-item" key={s.label}>
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function About() {
  const ref = useReveal();
  return (
    <section id="about">
      <div className="container">
        <div className="about-grid" ref={ref}>
          {/* Content col (Left, overlapping image) */}
          <div className="about-content reveal" style={{ transitionDelay: '0.1s' }}>
            <p className="section-label">À propos de moi</p>
            <h2 className="section-title">
              Développeur qui transforme des<br />idées en solutions intelligentes
            </h2>

            <p>
              Je suis <strong>Yassine ALAOUI</strong>, développeur Web & AI basé à
              Casablanca, Maroc. Ma passion ? Construire des applications web intelligentes
              et performantes en intégrant l'intelligence artificielle — des agents
              intelligents aux modèles de machine learning.
            </p>
            <p>
              Avec plus de 2 ans d'expérience professionnelle, j'oriente mes projets vers
              l'IA appliquée : agents conversationnels, automatisation intelligente,
              intégration de LLMs dans des plateformes web, et développement d'outils
              d'aide à la décision. J'aime repousser les limites du web en y ajoutant
              une couche d'intelligence.
            </p>

            <div className="about-info-grid">
              <div className="about-info-item">
                <div className="about-info-key">Poste</div>
                <div className="about-info-val">Développeur Web & AI</div>
              </div>
              <div className="about-info-item">
                <div className="about-info-key">Localisation</div>
                <div className="about-info-val">Casablanca, Maroc</div>
              </div>
              <div className="about-info-item">
                <div className="about-info-key">Disponibilité</div>
                <div className="about-info-val" style={{ color: 'var(--success-color)' }}>✓ Ouvert aux missions</div>
              </div>
              <div className="about-info-item">
                <div className="about-info-key">Email</div>
                <div className="about-info-val">yassinealaoui095@gmail.com</div>
              </div>
            </div>
          </div>

          {/* Image col (Right) */}
          <div className="about-image-col reveal" style={{ transitionDelay: '0.2s' }}>
            <img src="/4871f1da-f062-429d-8576-c527093d5edb.png" alt="Yassine ALAOUI" style={{ objectPosition: 'center 10%' }} />
            <div className="about-badge">
              Disponible<br />pour missions
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
